import { Utils, BaseModel } from '../../../..'
import { BackendStrategy } from '../..'
import { IKeyStrategy } from '.'

export class RequestKeyStrategy implements IKeyStrategy<BaseModel> {
  constructor(private _utils: Utils) {}

  public findById(type: string, id: string, includes?: string[]): string {
    return this._findKeyStrategy(type, {id: id})
  }

  public findBy(type: string, searchCriteria: any, includes?: string[]): string {
    return this._findKeyStrategy(type, searchCriteria)
  }

  public save(models: BaseModel|BaseModel[]): string[] {
    return this._modelKeyStrategy(models)
  }

  public delete(models: BaseModel|BaseModel[]): string[] {
    return this._modelKeyStrategy(models)
  }

  private _findKeyStrategy(type: string, searchCriteria: {[key: string]: any}): string {
    const sortedSearchCriteria = this._utils.getSortedObject(this._ensureIdTypedAsString(searchCriteria))
    const searchCriteriaHash = this._utils.hashCode(JSON.stringify(sortedSearchCriteria))
    return `${type}_${searchCriteriaHash}`
  }

  private _modelKeyStrategy(model: BaseModel|BaseModel[]): string[] {
    const models = Array.isArray(model) ? model : [model]
    const uniqueTypes = models.reduce((result, mdl) => result.add(mdl.type), new Set<string>())
    return Array.from(uniqueTypes)
  }

  private _ensureIdTypedAsString(searchCriteria: {[key: string]: any}) {
    if (typeof searchCriteria === 'object' && typeof searchCriteria.id === 'number') {
      searchCriteria.id = String(searchCriteria.id)
    }
    return searchCriteria
  }

}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/model-repository/backends/model-request-store/request-key-strategy/request-key-strategy.ts